import React, { useState } from 'react';
import { IconButton, Typography, Box } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

interface ToggleableValueDisplayProps {
  value: string;
  className?: string;
}

const ToggleableValueDisplay: React.FC<ToggleableValueDisplayProps> = ({ value, className }) => {
  const [visible, setVisible] = useState(false);

  const handleToggleVisibility = () => {
    setVisible((prev) => !prev);
  };

  return (
    <Box sx={(t) => ({ display: 'flex', alignItems: 'center', gap: t.spacing(1) })}>
      <Typography variant="body2" className={className}>
        {visible ? value : '*'.repeat(value.length)}
      </Typography>
      <IconButton onClick={handleToggleVisibility} size="small">
        {visible ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
      </IconButton>
    </Box>
  );
};

export default ToggleableValueDisplay;
